import { Array, pipe, Record, Result } from 'effect'
import { isNotNullish } from 'effect/Predicate'

// propertyがundefined,nullだった場合にneverとする
type FilterBlank<Base> = {
  [Key in keyof Base]: Base[Key] extends undefined | null ? never : Key
}

// undefined,null以外のkeyのunion型を生成
type AllowedNames<Base> = FilterBlank<Base>[keyof Base]

// 上記をもとに、元の型からPickする
type PickPresentType<Base> = Pick<Base, AllowedNames<Base>>

export const recordTransformKeys =
  <Key extends string, V>(f: (key: Key, value: V, self: Record<Key, V>) => string | undefined) =>
  (self: Record<Key, V>): Record<string, V> =>
    pipe(
      self,
      Record.toEntries,
      Array.filterMap(([key, value]) => {
        const newKey = f(key, value, self)
        return newKey === undefined ? Result.failVoid : Result.succeed([newKey, value] as [string, V])
      }),
      Record.fromEntries,
    )

/** null or undefined のフィールドの削除 */
export const recordCompact = <T extends Record<string, unknown>>(self: T): PickPresentType<T> =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  Record.filter(self, isNotNullish) as PickPresentType<T>

// string | nullのようなプロパティに対してoptionalにするのを実現できなかったため、必要な時のみこちらを使うのを想定
export function findValueInRecord<T>(attributes: Record<string, T>, pred: (k: string) => boolean): T | undefined {
  const pair = Object.entries(attributes).find(([key, value]) => pred(key))
  return pair?.[1]
}
